import { createAction } from "redux-actions";
import { GET_AGREEMENT_TYPES, UPDATE_AGREEMENT_TYPES } from "../constants";
import { feathersFindGET } from "../services";

export const getAgreementTypes = createAction(GET_AGREEMENT_TYPES, () => feathersFindGET('agreement-types', {$limit: 100})())
export const updateAgreementTypes = createAction(UPDATE_AGREEMENT_TYPES, (state) => state)